/**
 * Hydrate a deleted source name with a "(Deleted)" suffix.
 * @param name - The source name to hydrate
 * @returns The hydrated source name
 */
export function hydrateDeletedSourceName(name: string): string {
  return name.replace(/_deleted_\d+$/, "");
}
